import React from 'react';
import { Button } from '@components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@components/ui/tooltip';
import { toast } from '@core/toast';

export const copyEmail = (email: string) => {
    navigator.clipboard.writeText(email);
    toast.success(`${email} was copied to the clipboard`);
};

export const CopyEmailButton = ({ email }: { email: string }) => (
    <Tooltip>
        <TooltipTrigger asChild>
            <Button
                variant="ghost"
                size="sm"
                className="max-w-full"
                onClick={() => void copyEmail(email)}
            >
                <span className="truncate">{email}</span>
            </Button>
        </TooltipTrigger>
        <TooltipContent side="top" align="start">
            {email}
        </TooltipContent>
    </Tooltip>
);
